import {useTranslation} from "react-i18next";
import Logo from '../../Assets/images/logo/connectcaremintgreen.png';
import {Link, useNavigate} from "react-router-dom";
import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import * as yup from "yup";
import toast from "react-hot-toast";
import {PrimaryButton} from "../../Components/Buttons/PrimaryButton";
import {TextInput} from "../../Components/Form/TextInput";
import {useBoundStore} from "../../Store/store";

export const ForgotPassword = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const forgotPassword = useBoundStore(state => state.forgotPassword);


    const schema = yup
        .object({
            email: yup.string().email().required(),
        })
        .required()

    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm({
        resolver: yupResolver(schema),
    })

    const onSubmit = (data) => {
        forgotPassword(data.email).finally(() => {
            toast.success(t('auth.forgot_email_sent'));
            navigate('/');
        });
    }


    return (
        <div className={'flex flex-col justify-center h-screen w-full'}>
            <div className={'p-3 text-center'}>
                <img src={Logo} alt={'Logo for connect care mint green'} className={'max-h-16 mx-auto'}/>
            </div>
            <div className={'p-3 w-full max-w-[80%] md:max-w-[50%] mx-auto'}>
                <form className="w-full" onSubmit={handleSubmit(onSubmit)}>
                    <div className={'mb-4'}>
                        <TextInput
                            label={'Email'}
                            name={'email'}
                            register={register}
                            translationIndex={'general.fields.email'}
                            errors={errors}
                        />
                    </div>
                    <div className={'mt-4 mb-1'}>
                       <PrimaryButton type={'submit'}>
                           {t('auth.forgot_password.submit_button')}
                       </PrimaryButton>
                    </div>
                    <div className={'text-center mt-3'}>
                        <Link className={'text-primary hover:text-opacity-50 transition-all duration-300'} to={'/'}>
                            {t('auth.forgot_password.back_to_login')}
                        </Link>
                    </div>
                </form>
            </div>
        </div>
    )
}